import projImg1 from "../assets/img/kangaroo1.png";
import projImg2 from "../assets/img/kangaroo2.png";
import projImg3 from "../assets/img/kangaroo3.png";
import projImg4 from "../assets/img/aminute1.png";
import projImg5 from "../assets/img/aminute2.png";
import projImg6 from "../assets/img/aminute3.png";
// App ui image////////////
import app1 from "../assets/img/BestNepal/boomracing.png";
import app2 from "../assets/img/BestNepal/scaletra.png";
import app3 from "../assets/img/BestNepal/atees.png";
import app4 from "../assets/img/BestNepal/finye.png";
import app5 from "../assets/img/BestNepal/lumle.png";
import app6 from "../assets/img/BestNepal/eventpapa.png";
// startup ui image////////////
import start1 from "../assets/img/startups/image 4.png";
import start2 from "../assets/img/startups/image 3.png";
import start3 from "../assets/img/startups/image 2.png";
import start4 from "../assets/img/appui/snapgreet1.png";
import start5 from "../assets/img/Blissful_Bash.jpg";
import start6 from "../assets/img/Joyful_Jubilee.jpg";
export const projectsData = [
    {
        slug: "kangaroo-kids",
        title: "Kangaroo Kids",
        description: "Kindergarten School Website",
        category: "Education",
        image: projImg1,
        website: "https://kangarookids.edu.np/",
        technologies: ["React", "Bootstrap", "Node.js", "MongoDB"],
        overview: "A modern, colorful kindergarten website designed to engage young learners and provide parents with easy access to school information. The platform features interactive elements, a vibrant color scheme, and intuitive navigation suitable for both children and parents.",
        details: "The Kangaroo Kids website was built with a focus on creating an engaging digital presence for the kindergarten. The design incorporates playful elements while maintaining professional standards for parent communication.",
        features: [
            "Responsive design that works on all devices",
            "Kids-friendly UI with animated characters",
            "Interactive photo gallery for school events",
            "Parent portal with announcements and updates",
            "Online admission inquiry system",
            "Curriculum showcase section"
        ],
        client: "Kangaroo Kids Kindergarten",
        timeline: "3 months",
        role: "Lead Frontend Developer",
        specialFeature: {
            image: projImg1, // Add a specific image for the feature
            description: "Interactive learning section with animated characters that guide children through the school's curriculum and daily activities, making the website both informative and entertaining."
        },
        additionalImages: [
            projImg1,
            projImg1,
            // Add more images as needed
        ],
        github: "https://github.com/yourusername/kangaroo-kids" // Optional
    },

    {
        slug: "snooker-bar",
        title: "Snooker Bar Website",
        description: "Sports Bar Design",
        category: "social",
        image: projImg2,
        website: "https://snookeraminute.netlify.app/",
        technologies: ["React", "Tailwind"],
        overview:
            "A modern sports bar website with stylish UI and responsive layout.",
        features: [
            "Menu system",
            "Gallery",
            "Booking system",
        ],
    },

];

export const startupData = [
    {
        id: 'invenzo',
        slug: 'invenzo',
        title: "Invenzo (Inventory Management System)",
        description: "Dashboard Design & Development",
        imgUrl: "/assets/img/startups/image 4.png",
        url: "https://missin-dependent.com/",
        details: "Complete inventory management solution for small businesses.",
        technologies: ["React", "Firebase", "Material UI"]
    },
    {
        id: 'snapgreet',
        slug: 'snapgreet',
        title: "SnapGreet",
        description: "Design & Development",
        imgUrl: "/assets/img/appui/snapgreet1.png",
        url: "https://snap-greet.com",
        details: "A new way of greeting with customizable templates.",
        technologies: ["React", "Node.js"]
    },
    // Other startups
];

export const appsData = [
    {
        id: 'boomracing',
        slug: 'boomracing',
        title: "Boomracing RC",
        description: "Refactoring Design and Development",
        imgUrl: "/assets/img/BestNepal/boomracing.png",
        url: "https://www.boomracing.com/",
        details: "E-commerce site for RC car parts and accessories.",
        technologies: ["WordPress", "WooCommerce", "PHP"]
    },
    {
        id: 'scaletra',
        slug: 'scaletra',
        title: "Scaletra",
        description: "Design & Development",
        imgUrl: "/assets/img/BestNepal/scaletra.png",
        url: "https://scaletra.com/",
        details: "Business scaling platform.",
        technologies: ["React", "Node.js"]
    },
    {
        id: 'asiatees',
        slug: 'asiatees',
        title: "AsiaTees",
        description: "Refactoring Design and Development",
        imgUrl: "/assets/img/BestNepal/atees.png",
        url: "https://www.asiatees.com/",
        details: "E-commerce for custom t-shirts.",
        technologies: ["WordPress", "WooCommerce"]
    },
    {
        id: 'finye',
        slug: 'finye',
        title: "FINYE ORG",
        description: "Refactoring Design and Development",
        imgUrl: "/assets/img/BestNepal/finye.png",
        url: "https://finye.org/",
        details: "Financial organization website.",
        technologies: ["WordPress"]
    },
    {
        id: 'lumle',
        slug: 'lumle',
        title: "Lumle Holidays",
        description: "Refactoring Design and development of Wordpress website",
        imgUrl: "/assets/img/BestNepal/lumle.png",
        url: "https://www.lumle.com/",
        details: "Travel and holiday booking site.",
        technologies: ["WordPress"]
    },
    {
        id: 'eventpapa',
        slug: 'eventpapa',
        title: "Event Papa",
        description: "UI/UX and Development",
        imgUrl: "/assets/img/BestNepal/eventpapa.png",
        url: "https://www.figma.com/design/FtI9exW19Yb9frJyXYU2kl/Event-Papa-Redesigning?node-id=128-609&t=bycf7LYD5bFqK40c-1",
        details: "Event management platform.",
        technologies: ["React", "Figma"]
    },
    // Other apps
];